import { Amplify } from 'aws-amplify';
import {
  signIn,
  signUp,
  signOut,
  confirmSignUp,
  resetPassword,
  confirmResetPassword,
  getCurrentUser,
  fetchAuthSession,
} from 'aws-amplify/auth';
import { COGNITO_CONFIG } from '@/utils/constants';

// Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: COGNITO_CONFIG.USER_POOL_ID,
      userPoolClientId: COGNITO_CONFIG.CLIENT_ID,
    },
  },
});

export interface SignUpParams {
  email: string;
  password: string;
  name?: string;
}

export interface SignInParams {
  email: string;
  password: string;
}

export const authService = {
  async signUp({ email, password, name }: SignUpParams) {
    const result = await signUp({
      username: email,
      password,
      options: {
        userAttributes: {
          email,
          name: name || '',
        },
      },
    });
    return result;
  },

  async confirmSignUp(email: string, code: string) {
    const result = await confirmSignUp({
      username: email,
      confirmationCode: code,
    });
    return result;
  },

  async signIn({ email, password }: SignInParams) {
    const result = await signIn({
      username: email,
      password,
    });
    return result;
  },

  async signOut() {
    await signOut();
  },

  async getCurrentUser() {
    try {
      const user = await getCurrentUser();
      return user;
    } catch {
      return null;
    }
  },

  async getIdToken(): Promise<string | null> {
    try {
      const session = await fetchAuthSession();
      return session.tokens?.idToken?.toString() || null;
    } catch {
      return null;
    }
  },

  async resetPassword(email: string) {
    const result = await resetPassword({ username: email });
    return result;
  },

  async confirmResetPassword(email: string, code: string, newPassword: string) {
    const result = await confirmResetPassword({
      username: email,
      confirmationCode: code,
      newPassword,
    });
    return result;
  },
};
